/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShadowEventAttributes = {
  shadowEventType?: ShadowEventAttributes.shadowEventType;
  shadowTriggerType?: ShadowEventAttributes.shadowTriggerType;
  level?: number;
  notifyImmediately?: boolean;
};
export namespace ShadowEventAttributes {
  export enum shadowEventType {
    TEMPERATURE_MIN = 'TEMPERATURE_MIN',
    TEMPERATURE_MAX = 'TEMPERATURE_MAX',
    HUMIDITY_MIN = 'HUMIDITY_MIN',
    HUMIDITY_MAX = 'HUMIDITY_MAX',
    AIR_QUALITY_MODERATE = 'AIR_QUALITY_MODERATE',
    AIR_QUALITY_DANGEROUS = 'AIR_QUALITY_DANGEROUS',
  }
  export enum shadowTriggerType {
    TRIG_UP = 'TRIG_UP',
    TRIG_DWN = 'TRIG_DWN',
    TRIG_UPDWN = 'TRIG_UPDWN',
  }
}

